import React from 'react';
import './FeaturesSection.css';
import ReliableIcon from '../images/hand.png';
import indiaFlagIcon from '../images/india.jpg'; 
import pencilIcon from '../images/Desgin.png';
import certified from '../images/certified.png';
import expertise from '../images/customer-review.png';
import custom from '../images/customization.png';
import collab from '../images/team-collaboration.png';
import price from '../images/competitive.png';
import { Carousel } from 'react-responsive-carousel';
import { Helmet } from 'react-helmet';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const FeaturesSection = () => {
  return (
    <section className="features-section" aria-label="Why Choose Us - Pushkar Enterprises">
      <Helmet>
        <title>Why Choose Us - Pushkar Enterprises | Soft Toy Accessories Manufacturer</title>
        <meta name="description" content="Explore the key features that make Pushkar Enterprises a trusted manufacturer of premium soft toy eyes, noses, and accessories made in India." />
        <meta name="keywords" content="Soft toy accessories, Toy eyes manufacturer, Toy noses, Plastic molding, Custom toy parts, Pushkar Enterprises, Made in India toys" />
        <meta name="author" content="Pushkar Enterprises" />
        <meta property="og:title" content="Why Choose Pushkar Enterprises for Soft Toy Components" />
        <meta property="og:description" content="We manufacture certified, customizable toy eyes and noses with competitive pricing and design collaboration." />
        <meta property="og:image" content="https://pushkar-enterprises.web.app/logo.png" />
        <meta property="og:url" content="https://pushkarenterprises.ltd" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://pushkarenterprises.ltd" />
      </Helmet>

      <Carousel 
        showThumbs={false}
        showStatus={false}
        showIndicators={true}
        infiniteLoop={true}
        centerMode={true}
        centerSlidePercentage={33.33}
        autoPlay={true}
        interval={3000}
        emulateTouch={true}
        swipeable={true}
        stopOnHover={true}
        dynamicHeight={false}
      >
        <div className="feature">
          <div className="feature-icon">
            <img src={ReliableIcon} alt="Reliable raw material sourcing for soft toy components" loading="lazy" />
          </div>
          <h3 className="feature-title">Commitment to Quality</h3>
          <p className="feature-description">
            We ensure unmatched quality and customer satisfaction by using premium materials and following rigorous testing protocols.
          </p>
        </div>

        <div className="feature">
          <div className="feature-icon">
            <img src={indiaFlagIcon} alt="Indian manufactured toy accessories" loading="lazy" />
          </div>
          <h3 className="feature-title">Made in India Products</h3>
          <p className="feature-description">
            Proudly manufacturing high-quality soft toy components in India, supporting local industries and artisans.
          </p>
        </div>

        <div className="feature">
          <div className="feature-icon">
            <img src={pencilIcon} alt="Custom in-house toy eye and nose design" loading="lazy" />
          </div>
          <h3 className="feature-title">In-House Design Expertise</h3>
          <p className="feature-description">
            Our experienced design team crafts unique soft toy eyes and noses tailored to your brand and creativity.
          </p>
        </div>

        <div className="feature">
          <div className="feature-icon">
            <img src={expertise} alt="Specialized plastic molding for stuffed toys" loading="lazy" />
          </div>
          <h3 className="feature-title">Plastic Molding Expertise</h3>
          <p className="feature-description">
            Precision molding technology ensures our eyes and noses are safe, durable, and fit plush toys perfectly.
          </p>
        </div>

        <div className="feature">
          <div className="feature-icon">
            <img src={certified} alt="Certified and safe plastic materials" loading="lazy" />
          </div>
          <h3 className="feature-title">High-Quality Plastic Materials</h3>
          <p className="feature-description">
            We use only certified, non-toxic plastic materials that comply with international safety standards for children's toys.
          </p>
        </div>

        <div className="feature">
          <div className="feature-icon">
            <img src={custom} alt="Customizable toy accessories - eyes and noses" loading="lazy" />
          </div>
          <h3 className="feature-title">Customizable Products</h3>
          <p className="feature-description">
            Offering wide options in shape, size, and color to create personalized toy accessories that match your vision.
          </p>
        </div>

        <div className="feature">
          <div className="feature-icon">
            <img src={price} alt="Affordable pricing for bulk toy parts" loading="lazy" />
          </div>
          <h3 className="feature-title">Competitive Pricing Strategy</h3>
          <p className="feature-description">
            High-quality products at factory-direct prices — maximizing value without compromising on quality.
          </p>
        </div>

        <div className="feature">
          <div className="feature-icon">
            <img src={collab} alt="Collaborative toy design service" loading="lazy" />
          </div>
          <h3 className="feature-title">Design Collaboration Services</h3>
          <p className="feature-description">
            We work closely with clients to co-create perfect toy components, ensuring satisfaction at every stage.
          </p>
        </div>
      </Carousel>
    </section>
  );
};

export default FeaturesSection;
